import script from "./FactoidsPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./FactoidsPage.vue?vue&type=script&setup=true&lang=ts"

import "./FactoidsPage.vue?vue&type=style&index=0&id=5172740a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5172740a"]])

export default __exports__